<template>
  <div>
    <Navbar />
    <div
      class="aspect-4/3 md:aspect-21/9 bg-cover bg-center flex items-center justify-center"
      :style="{ backgroundImage: 'url(/img/circle-bg.jpeg)' }">
      <div class="standard-spacing">
        <h1 class="heading-1">Hoap Library</h1>
      </div>
    </div>
    <div class="bg-gradient-midnight">
      <div class="standard-spacing py-8">
        <div class="flex items-center justify-center space-x-8 pb-12">
          <button
            class="text-lg"
            :class="selectedTab === 'blogs' ? 'font-medium underline' : 'font-light'"
            @click="selectedTab = 'blogs'">
            Blogs
          </button>
          <button
            class="text-lg"
            :class="selectedTab === 'videos' ? 'font-medium underline' : 'font-light'"
            @click="selectedTab = 'videos'">
            Video
          </button>
        </div>
        <BlogsList v-if="selectedTab === 'blogs'" />
        <VideosList v-else-if="selectedTab === 'videos'" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Ref } from 'vue'

  const route = useRoute()
  const selectedTab = ref('blogs')
  const { showVideo } = useLightbox()

  const videoVimeoId: Ref<string> = ref(route.query['video-id']?.toString() ?? '')

  onMounted(async () => {
    if (videoVimeoId.value) showVideo({ id: videoVimeoId.value })
  })

  setMetadata({ pageTitle: 'Library' })
</script>
